import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

function MitochondrialMessage({ genome, multipleResults, variantResult }) {
  const results =
    Array.isArray(multipleResults) && multipleResults.length
      ? multipleResults
      : variantResult;

  let chrMFound = false;
  let MTFound = false;
  let found = false;
  if (genome.name === "hg19") {
    if (Array.isArray(results)) {
      for (let i = 0; i < results.length; i++) {
        if (results[i].chromosome === "chrM") {
          chrMFound = true;
        }
        if (results[i].chromosome === "MT") {
          MTFound = true;
        }
      }
    } else if (results.chromosome === "chrM" || results.chromosome === "MT") {
      found = true;
    }
  }

  if ((chrMFound && MTFound) || found) {
    return (
      <a
        className="tw-inline-block tw-mb-2 tw-no-underline tw-text-white tw-text-xs tw-relative tw--top-1 hover:tw-text-white hover:tw-underline"
        href="https://docs.varsome.com/mito-genome-versions"
        target="_blank"
      >
        Learn about the implementation of the mitochondrial genome on VarSome.
      </a>
    );
  }

  return null;
}

MitochondrialMessage.propTypes = {
  genome: PropTypes.shape({ name: PropTypes.string, id: PropTypes.number }),
  // eslint-disable-next-line react/forbid-prop-types
  multipleResults: PropTypes.arrayOf(PropTypes.any),
  variantResult: PropTypes.shape({}),
};

MitochondrialMessage.defaultProps = {
  genome: {},
  multipleResults: [],
  variantResult: {},
};

const mapStateToProps = (state) => ({
  genome: state.genome,
  multipleResults: state.multipleResults,
  variantResult: state.variantResult,
});

export default connect(mapStateToProps)(MitochondrialMessage);
